// Dispara la descarga de un blob (ej. un PDF recibido por axios con responseType: 'blob')
// en el navegador del usuario, sin depender de un enlace <a> ya presente en el DOM.
export function triggerBlobDownload(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

// Abre un blob (ej. un PDF) en una pestaña nueva en vez de forzar su descarga, para poder
// revisarlo/imprimirlo con el dialogo de impresion del navegador (ver "Vista previa" de
// boletas/facturas, que no descarga un archivo sino que solo se muestra para imprimir).
export function openBlobInNewTab(blob) {
  const url = window.URL.createObjectURL(blob);
  const opened = window.open(url, '_blank', 'noopener');
  // Revocar de inmediato dejaria la pestaña nueva sin PDF que mostrar (la carga es asincrona),
  // asi que se libera recien despues de un rato en vez de nunca liberarla.
  setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
  return opened;
}

// Manda un blob (ej. un PDF en formato ticket de 80mm) directo al dialogo de impresion del
// navegador, sin descargarlo ni abrir otra pestaña: se carga en un iframe oculto y se llama
// a print() sobre el. Elegir ahi la tiketera (ej. Fukun FK-POS80-BF) con escala 100%.
export function printBlob(blob) {
  const url = window.URL.createObjectURL(blob);
  const iframe = document.createElement('iframe');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  iframe.src = url;
  iframe.onload = () => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
  };
  document.body.appendChild(iframe);
  // El dialogo de impresion no avisa cuando se cierra: se limpia despues de un rato largo.
  setTimeout(() => {
    iframe.remove();
    window.URL.revokeObjectURL(url);
  }, 60_000);
}
